import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, Secondary, Text } from "@cinch-labs/design-system";
import { buildTagDataAttr, sendDigitalDataEvent } from "@cinch-nx/shared-analytics";
import debounce from "lodash/debounce";
import React, { useState } from "react";
import styles from "./modal-chat.module.css";
export var whatsAppHref = "https://wa.me/447585658040";
export var smsHref = "sms:+442033224567";
export var sendChatModalOpenEvent = debounce(function() {
    var data = {
        event: {
            name: "click",
            category: "chatModal",
            label: "Chat Modal",
            action: "open"
        }
    };
    sendDigitalDataEvent(data);
}, 100);
export var ModalChat = function() {
    var ref = useState(false), showModal = ref[0], setShowModal = ref[1];
    var whatsAppButtonText = "WhatsApp";
    var smsButtonText = "Text message";
    var handleOpenModal = function() {
        sendChatModalOpenEvent();
        setShowModal(true);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles["container"],
        children: [
            /*#__PURE__*/ _jsx("button", {
                className: styles["button"],
                onClick: handleOpenModal,
                "data-testid": "chat",
                children: "Chat"
            }),
            showModal && /*#__PURE__*/ _jsxs(Modal, {
                titleId: "live-chat-title",
                bodyId: "live-chat-body",
                title: "Live chat support",
                onClose: function() {
                    return setShowModal(false);
                },
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        className: styles.text,
                        element: "p",
                        fontWeight: "book",
                        fontSize: "m",
                        lineHeight: "display",
                        children: "How would you like to chat?"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.buttonContainer,
                        children: [
                            /*#__PURE__*/ _jsx(Secondary, _object_spread_props(_object_spread({
                                isFullWidth: true
                            }, buildTagDataAttr({
                                event: "click",
                                eventCategory: "whatsApp",
                                eventLabel: whatsAppButtonText,
                                eventAction: "open"
                            })), {
                                element: "a",
                                href: whatsAppHref,
                                children: /*#__PURE__*/ _jsx("span", {
                                    children: whatsAppButtonText
                                })
                            })),
                            /*#__PURE__*/ _jsx(Secondary, _object_spread_props(_object_spread({
                                isFullWidth: true
                            }, buildTagDataAttr({
                                event: "click",
                                eventCategory: "sms",
                                eventLabel: smsButtonText,
                                eventAction: "open"
                            })), {
                                element: "a",
                                href: smsHref,
                                children: /*#__PURE__*/ _jsx("span", {
                                    children: smsButtonText
                                })
                            }))
                        ]
                    })
                ]
            })
        ]
    });
};
